import React from 'react'
import { Props_SnippetHeading} from './Heading.props'

const SnippetHeading = (props: Props_SnippetHeading) => {
    const { snippet } = props
    
    return (
        <section className={`snippet-heading snippet-heading--alignment-${snippet.alignment.value}`}>
            { snippet?.level?.value && React.createElement(snippet.level.value, { className: 'snippet-heading__heading' }, snippet?.heading?.value) }
        </section>
    )
}

export default SnippetHeading